<template>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název modelu' | translate">
      {{ entity.name }}
    </td>
    <td :data-th="'Počet operátorů' | translate">
      <span class="dotted" @click.stop="$refs.operatorsmodalref.showModal(true)" v-if="entity.operators.length > 0">
            {{ entity.operators.length }}
          <modal ref="operatorsmodalref">
            <div slot="title"><translate>Operátoři</translate> ({{entity.operators.length}})</div>
            <div slot="body">
              <ul>
                <li v-for="(item, index) in entity.operators" :key="'channels-'+index">
                  <entity-link :id="item.id" type="operator">{{ item.name }}</entity-link>
                </li>
              </ul>
            </div>
          </modal>
      </span>
      <span v-else>0</span>
    </td>
    <td :data-th="'Počet služeb' | translate">
      <span class="dotted" @click.stop="$refs.servicesmodalref.showModal(true)" v-if="entity.services.length > 0">
            {{ entity.services.length }}
          <modal ref="servicesmodalref">
            <div slot="title"><translate>Služby</translate> ({{entity.services.length}})</div>
            <div slot="body">
              <ul>
                <li v-for="(item, index) in entity.services" :key="'channels-'+index">
                  <entity-link :id="item.id" type="service">{{ item.name }}</entity-link>
                </li>
              </ul>
            </div>
          </modal>
      </span>
      <span v-else>0</span>
    </td>
    <td :data-th="'Počet balíčků' | translate">
            <span class="dotted" @click.stop="$refs.channelpackagesmodalref.showModal(true)" v-if="entity.channel_packages.length > 0">
            {{ entity.channel_packages.length }}
          <modal ref="channelpackagesmodalref">
            <div slot="title"><translate>Balíčky kanálů</translate> ({{entity.channel_packages.length}})</div>
            <div slot="body">
              <ul>
                <li v-for="(item, index) in entity.channel_packages" :key="'channels-'+index">
                  <entity-link :id="item.id" type="channelPackage">{{ item.name }}</entity-link>
                </li>
              </ul>
            </div>
          </modal>
      </span>
      <span v-else>0</span>
    </td>
    <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteBusinessModel">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "BusinessModelRow",
  components: { EntityLink },
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  data() {
    return {
      moduleName: 'businessModels',
      detailPageRouteName: 'businessModelsDetail',
    }
  },
  methods: {
    emitDeleteBusinessModel() {
      this.$emit('deleteBusinessModel', String(this.entity.id))
    },
  },
  computed: {
    operatorNames() {
      return this.entity.operators.map((operator) => operator.name).join(", ");
    },
    channelPackageNames() {
      return this.entity.channel_packages.map((channelPackage) => channelPackage.name).join(", ");
    },
    serviceNames() {
      return this.entity.services.map((service) => service.name).join(", ");
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/businessModels/BusinessModelRow.vue